import { render, staticRenderFns } from "./BasicCategoryAnalysis.vue?vue&type=template&id=3749991a&scoped=true&"
import script from "./BasicCategoryAnalysis.vue?vue&type=script&lang=js&"
export * from "./BasicCategoryAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./BasicCategoryAnalysis.vue?vue&type=style&index=0&id=3749991a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3749991a",
  null
  
)

export default component.exports